import { Payload } from "@/types/type";
import { EPrefixMenuTypes } from "@/pages/newHome/components/chatInput/components/chatInputPrefix/chatInputPrefixMenu/constants";
import type { ResumeHomePromptPayload } from "@/const";

export interface IChatInput {
  currentInputMenuType: EPrefixMenuTypes | null;
  hasTour: boolean;
  hasFileTour: boolean;
  tourTxt: string;
  fileTourTxt: string;
  tourPlace: "top" | "bottom";
  pendingLoginHomePrompt: ResumeHomePromptPayload | null;
}

export default {
  state: {
    currentInputMenuType: null,
    // 是否出现输入框引导
    hasTour: false,
    // 引导文案
    tourTxt: "",
    // 文件/图片解读 是否出现输入框引导
    hasFileTour: false,
    // 引导文案
    fileTourTxt: "",
    tourPlace: "bottom",
    pendingLoginHomePrompt: null,

  } as IChatInput,
  reducers: {
    setCurrentInputMenuType: (state: IChatInput, { payload }: Payload) => {
      return {
        ...state,
        currentInputMenuType: payload,
      };
    },

    setHasTour: (state: IChatInput, { payload }: Payload) => {
      return {
        ...state,
        hasTour: payload,
        // 两个引导共享页面遮罩，开启时原子切换，避免叠加。
        ...(payload ? { hasFileTour: false, fileTourTxt: "" } : {}),
      };
    },

    setTourTxt: (state: IChatInput, { payload }: Payload) => {
      return {
        ...state,
        tourTxt: payload,
      };
    },

    setHasFileTour: (state: IChatInput, { payload }: Payload) => {
      return {
        ...state,
        hasFileTour: payload,
        ...(payload ? { hasTour: false, tourTxt: "" } : {}),
      };
    },

    setFileTourTxt: (state: IChatInput, { payload }: Payload) => {
      return {
        ...state,
        fileTourTxt: payload,
      };
    },
    setTourPlace: (state: IChatInput, { payload }: Payload) => {
      return {
        ...state,
        tourPlace: payload,
      };
    },
    setPendingLoginHomePrompt: (
      state: IChatInput,
      { payload }: Payload,
    ) => {
      return {
        ...state,
        pendingLoginHomePrompt: payload,
      };
    },
  },
};
